"use strict";
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BuildinUserAuthorizationType = void 0;
/**
 * 用户授权类型
 */
var BuildinUserAuthorizationType;
(function (BuildinUserAuthorizationType) {
    BuildinUserAuthorizationType[BuildinUserAuthorizationType["EMAIL"] = 1] = "EMAIL";
    BuildinUserAuthorizationType[BuildinUserAuthorizationType["APPLE"] = 2] = "APPLE";
    BuildinUserAuthorizationType[BuildinUserAuthorizationType["PASSWORD"] = 5] = "PASSWORD";
})(BuildinUserAuthorizationType = exports.BuildinUserAuthorizationType || (exports.BuildinUserAuthorizationType = {}));
